<template>
  <el-container v-if="!$route.query.appid">
    <el-header class="!h-[56] min-w-[1200] head pl-[0] flex justify-between bg-[#00152a] items-center pr-[32]">
      <div class="flex items-center">
        <p class="h-[56] w-[56] bg-[theme] rounded-tr-[12] text-center leading-[56]"
          v-if="['yi-bin'].indexOf(conf.city) == -1">
          <i v-if="conf.logoIcon" class="iconfont-logo t-[#fff] t-[40]" :class="conf.logoIcon"></i>
          <img v-else class="w-[40]" :src="getCityAssetsFile('logo.png')" alt="" />
        </p>
        <p class="t-[#fff] pl-[12] t-[16] font-700 ff-[yiBin]">{{ conf.name }}</p>
      </div>
      <div class="flex t-[#fff]">
     
        <div class="relative mr-[36] cursor-pointer" @click="push('/notify/list')">
          <i class="icon">&#xe62d;</i>
          <span>消息</span>

          <span
            class="absolute w-[16] text-center leading-[16] h-[16] top-[-10] right-[-10] t-[#fff] bg-[#FF0000] rounded-[100] t-[10]"
            v-show="messageCount">{{ messageCount > 100 ? "99+" : messageCount }}</span>
        </div>
        <div class="relative mr-[36] cursor-pointer" @click="wopen(ENV.official)">
          <i class="icon">&#xe67d;</i>
          <span>官网</span>
        </div>
        <!-- <div class="relative mr-[80] cursor-pointer">
          <el-popover placement="bottom-end" width="315" trigger="hover" popper-class="popper-phone">
            <div slot="reference" class="item cursor-pointer">
              <i class="icon">&#xe624;</i>
              <span>客服</span>
            </div>
            <div class="">
              <div>
                <div class="flex justify-start">
                  <div class="flex justify-start items-center h-[20]">
                    <img class="mr-[4]" width="16" height="16" src="@/assets/img/xiaojin/phone.png" alt="" />
                    <span class="t-[14]" style="white-space: nowrap">客服热线：</span>
                  </div>
                  <div>
                    <p class="t-[14] t-[#303133]">{{ contact.telephone || "-" }}</p>
                    <p class="t-[14] t-[#303133]">{{ contact.telephoneReservation || "-" }}</p>
                  </div>
                </div>
                <div class="flex justify-start">
                  <div class="flex justify-start items-center h-[20]">
                    <img class="mr-[4]" width="16" height="16" src="@/assets/img/xiaojin/cell.png" alt="" />
                    <span class="t-[14]" style="white-space: nowrap">服务时间：</span>
                  </div>
                  <span class="t-[14] t-[#303133]">{{ contact.customerServiceTime || "-" }}</span>
                </div>
              </div>
              <div class="flex text-center pt-[10]">
                <div class="pr-[10]" v-if="contact.officialQrCode">
                  <p><img :src="contact.officialQrCode" class="w-[84] h-[84]" alt="" /></p>
                  <p class="pt-[4] t-[12]">公众号</p>
                </div>
                <div class="pr-[10]" v-if="contact.wechatQrCode">
                  <p><img :src="contact.wechatQrCode" class="w-[84] h-[84]" alt="" /></p>
                  <p class="pt-[4] t-[12]">客服微信</p>
                </div>
                <div v-if="contact.appletQrCode">
                  <p><img :src="contact.appletQrCode" class="w-[84] h-[84]" alt="" /></p>
                  <p class="pt-[4] t-[12]">小程序</p>
                </div>
              </div>
            </div>
          </el-popover>
        </div> -->

        <el-dropdown class="headimg-box" @command="handleCommand">
          <div class="flex items-center cursor-pointer">
            <p class="px-[4] t-[14] t-[#fff]">
              {{ current && current.user && current.user.realName ? current.user.realName : '' }}
            </p>
            <p class=""><i class="icon t-[#fff]">&#xe747;</i></p>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="info">个人信息</el-dropdown-item>
              <el-dropdown-item command="password">修改密码</el-dropdown-item>
              <el-dropdown-item command="exit">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-aside :width="isCollapse ? '60px' : '170px'" class="shadow aside bg-[#fff] p-[8] relative">
        <div v-if="isCollapse" class="shousuo cursor-pointer absolute right-[18] width-[22] height-[22] bottom-[24]"
          @click="changeCollapse">
          <img height="22" width="22" src="@/assets/img/public/zhan_kai.png" />
        </div>
        <div v-if="!isCollapse" class="shousuo cursor-pointer absolute right-[8] width-[22] height-[22] bottom-[24]"
          @click="changeCollapse">
          <img height="22" width="22" src="@/assets/img/public/shou_qi.png" />
        </div>
        <!-- <el-aside width="60px"> -->
        <div class="absolute bottom-[50] right-[4] z-[10] flex gg-wrap" v-if="adVisible">
          <div class="w-[162] h-[200] relative" v-if="adList.length > 0">
            <el-carousel height="200px" arrow="never" :indicator-position="adList.length > 1 ? 'bottom' : 'none'"
              trigger="click" :interval="5000">
              <el-carousel-item v-for="item in adList" :key="item.id">
                <a @click="handleClickAd(item)">
                  <img :src="item.imageUrl" class="w-[100%] h-[100%]" alt="">
                </a>
              </el-carousel-item>
            </el-carousel>
            <div class="absolute top-[8] right-[8] z-[10]">
              <i class="icon t-[12] t-[#cccccc] font-600" @click="handleCloseAd">&#xe641;</i>
            </div>
          </div>
        </div>

        <div class="aside-box" v-if="!isCollapse">
          <div class="menu-item cursor-pointer min-h-[38] py-[3] px-[0]" v-for="(v, index) in menuJson" :key="index"
            @click="directrouter(v, v.path)">
            <div class="menu-item-content relative h-[32] py-[6] px-[12] bg-[#fff] t-[#99A3B7]"
              :class="{ active: menuIndex == v.path && !v.children.length }">
              <p class="flex items-center whitespace-nowrap">
                <i class="icon t-[20] mr-[8] t-[#9E9B9B]" v-html="v.icon"
                  :class="{ '!t-[theme]': v.paths.indexOf(menuIndex) != -1 }"></i><span
                  :class="{ '!t-[theme]': v.paths.indexOf(menuIndex) != -1 }" class="t-[#303133]">{{ v.name
                  }}</span><el-badge v-if="v.path == '/points/index' && indexRedDot" is-dot
                  class="mx-[2] h-[10]"></el-badge>
              </p>
              <div class="arrow-icon absolute right-[0] top-[8]" v-if="v.children.length">
                <i class="el-icon-arrow-down"
                  :class="{ '!t-[theme]': v.children.length && v.paths.indexOf(menuIndex) != -1 }"
                  v-if="isH == v.path && v.paths && v.paths.indexOf(menuIndex) != -1"></i>
                <i class="el-icon-arrow-right t-[#909399]"
                  :class="{ '!t-[theme]': v.children.length && v.paths.indexOf(menuIndex) != -1 }" v-else></i>
              </div>
            </div>
            <template>
              <div class="cursor-pointer t-[4]"
                :style="{ height: isH == v.path && (v.paths && v.paths.indexOf(menuIndex)) != -1 ? v.children.length * 38 + 'px' : '0px', overflow: 'hidden', transition: '0.3s' }">
                <div class="set-item-content py-[3] px-[0]" v-for="(i, key) in v.children" :key="key">
                  <div class="menu-item-content leading-[20] t-[12] h-[32] py-[6] px-[12] bg-[#fff] t-[#909399]"
                    :class="{ active: menuIndex == i.path && i.path }" @click.stop="push(i.path)">
                    <p class="flex pl-[26] whitespace-nowrap">
                      <span class="">{{ i.name }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="aside-box-collapse" v-else>
          <div v-for="(v, index) in menuJson" :key="index" @click="directrouter(v, v.path)">
            <el-popover v-if="v.children.length" placement="right" width="180" trigger="hover"
              popper-class="popper-class">
              <template slot="reference">
                <div class="menu-item cursor-pointer h-[40] py-[8] px-[3]">
                  <div class="menu-item-conten h-[28] leading-[28] py-[0] px-[9] bg-[#fff] t-[#9E9B9B]"
                    :class="{ active: v.paths.indexOf(menuIndex) != -1 }">
                    <p class="flex"><i class="icon t-[20]" v-html="v.icon"></i></p>
                  </div>
                </div>
              </template>
              <div class="cursor-pointer" v-for="(i, key) in v.children" :key="key"
                :class="{ popoverActive: menuIndex == i.path && i.path }" @click.stop="push(i.path)">
                <p class="popperhover pl-[20] leading-[32] hover:t-[theme] hover:bg-[themeBrightColor10]">
                  <span class="">{{ i.name }}</span>
                </p>
              </div>
            </el-popover>
            <el-tooltip v-else class="item" effect="dark" :content="v.name" placement="right">
              <div class="menu-item cursor-pointer h-[40] py-[8] px-[3]">
                <div class="menu-item-conten h-[28] leading-[28] py-[0] px-[9] bg-[#fff] t-[#9E9B9B]"
                  :class="{ active: menuIndex == v.path && !v.children.length }">
                  <p class="flex">
                    <i class="icon t-[20]" v-html="v.icon"></i>
                    <el-badge v-if="v.path == '/points/index' && indexRedDot" is-dot class="mx-[2] h-[10]"></el-badge>
                  </p>
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
      </el-aside>
      <el-main class="min-w-[1024]" :style="contentStyle">
        <breadcrumb :breadcrumbList="breadcrumbList"></breadcrumb>
        <div class="pl-[16] pr-[16] pb-[16]" :class="{ 'pt-[8]': $route.name != 'index' }">
          <transition name="el-zoom-in-top" v-if="tips.msg">
            <div class="mt-[10]" v-show="tips.msg">
              <el-alert @close="
                () => {
                  tips.msg = '';
                  tips.type = 'error';
                }
              " :title="tips.msg" :type="tips.type" show-icon>
              </el-alert>
            </div>
          </transition>
          <router-view v-loading="showLoading" :key="$route.fullPath" :contact="contact" />
        </div>
      </el-main>
    </el-container>
    <dg-help v-show="showHelpDialog" :contact="contact"></dg-help>
    <!-- <dgLimitedDiglog v-if="showLimitedDiglog"></dgLimitedDiglog> -->
  </el-container>
  <router-view v-else v-loading="showLoading" :key="$route.fullPath" />
</template>

<script>
import menuJson from "../assets/js/menu";
// import breadcrumb from "../assets/js/breadcrumb";
import mixin from "@/assets/js/mixin";
import { isIE, recursiveSearch, rulTojson } from "@/assets/js/utils";
import analysisRoute from "../assets/js/breadcrumbList";
// import dgLimitedDiglog from "../components/dg-limited-diglog.vue";

let childrenArr = [];
menuJson.forEach((el) => {
  if (el.children && el.children.length) {
    childrenArr.push(el.children);
  }
});
let menusStructure = [];
childrenArr.forEach((el) => {
  menusStructure.push({
    paths: recursiveSearch(el, "children", "path"),
    children: el,
  });
});
export default {
  mixins: [mixin],
  components: {
    // dgLimitedDiglog,
  },
  data() {
    return {
      show_tag_txt: true,
      new_year_code: "",
      new_year_link: "",
      indexRedDot: false,
      // contact: {
      //   customerServicePhone: process.config.contact.phone ? process.config.contact.phone : "400-816-1767", // 服务电话
      //   customerServiceTime: "工作日 9:00-18:00", // 服务时间
      //   customerServiceWechatQrcode: require(`@/assets/img/city/${process.config.city}/ke_fu.png`), //客服二维码
      //   wechatPublicQrcode: ['ji-nan', 'fu-yang', 'chi-zhou'].indexOf(config.city) == -1 ? require(`@/assets/img/city/${process.config.city}/gzh.png`) : ''// 公众号
      // },
      contact: {
        customerServiceTime: "工作日 9:00-18:00", // 服务时间
        appletQrCode: "", //小程序码
        gmtCreate: "",
        gmtModified: "",
        id: 0,
        mobile: "", //客服联系方式
        officialQrCode: "", //公众号二维码
        tags: {},
        telephone: "", //座机或固定电话
        version: 0,
        wechatQrCode: "", //客服微信二维码
      },
      messageCount: 0,
      menuIndex: "",
      isH: "",
      menuJson,
      isCollapse: false,
      showLoading: false,

      tips: {
        msg: "",
        type: "error",
      },

      contentStyle: {
        height: window.innerHeight - 60 + "px",
        width: Math.max(window.innerWidth - 200, 1200) + "px",
      },
      current: {
        user: { realName: "" },
        yearTag: false,
      },
      breadcrumbList: [],
      showLimitedDiglog: false,
      adList: [],
      adVisible: true,
      showAd: true,
    };
  },
  watch: {
    $route: {
      handler(to) {
        if (["index", "applyIndex", "orderIndex", "couponIndex"].includes(to.name)) {
          this.showLimitedDiglog = true;
        }

        if (to.fullPath.indexOf("SSOLogin=1") != -1) {
          this.getCurrent();
        }
        // this.routePath = to.path;
        this.menuIndex = to.path;
        let routerQuery = window.localStorage.getItem("routerQuery") ? JSON.parse(window.localStorage.getItem("routerQuery")) : {};
        routerQuery[to.path] = to.query;
        window.localStorage.setItem("routerQuery", JSON.stringify(routerQuery));
        this.$nextTick(() => {
          this.breadcrumbList = analysisRoute(to);
        });
        this.ca_back();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    // getBreadcrumb() {
    //   return breadcrumb[this.$route.fullPath] || breadcrumb[this.$route.path] || [];
    // },
    showHelpDialog() {
      return ![''].includes(this.$route.path)
      // return !['/apply/contract', '/apply/peasant', '/apply/advance', '/apply/owner', '/apply/quality', '/apply/govContract', '/apply/govAdvance', '/apply/bidding', '/apply/lawsuit', '/apply/customs', '/apply/cultural', '/apply/bidSecurity', '/apply/govBidSecurity'].includes(this.$route.path)
    },
  },
  methods: {
    get_new_year_code() {
      ajax.post({
        url: "/customer/annualReport/annualReportQRCode",
        data: {},
        self: this,
        success: (res) => {
          if (res) {
            this.new_year_code = res.qrCodeUrl || ''
            this.new_year_link = res.url
            this.getCurrent()
          }
        },
      });
    },
    handleClickAd(item) {
      ajax.post({
        url: "/customer/homePageData/clickAds",
        data: {
          adId: item.id,
        },
        success: (res) => {
          if (res) {
            window.location.href = item.jumpParams;
          }
        },
        fail: () => {
          window.location.href = item.jumpParams;
        }
      });
    },
    //获取红点
    selectEventPoster() {
      ajax.post({
        url: "/customer/Integral/eventPoster",
        data: {},
        self: this,
        success: (res) => {
          this.indexRedDot = res.indexRedDot;
          this.$root.$emit("getEventPoster", res);
        },
      });
    },
    getContact() {
      ajax.post({
        url: "/customer/common/platformServiceDetail",
        data: {},
        self: this,
        success: (res) => {
          this.contact = { ...this.contact, ...res };
        },
      });
    },
    getCurrent() {
      ajax.post({
        url: "/customer/user/current",
        data: {},
        self: this,
        success: (res) => {
          console.log('获取当前用户信息11111111', res)
          if (res && res.user) {
            localStorage.setItem("current", JSON.stringify(res));
            this.current = JSON.parse(localStorage.getItem("current"));
            // window.fixOpen(window.location.origin,"_self")
          }
        },
      });
    },
    ca_back() {
      if (isIE()) {
        // 判断是否为同意驱动跳转的
        setTimeout(() => {
          if (window.location.pathname.indexOf("ca.html") > -1 && localStorage.getItem("history_url_caSeal")) {
            // window.history.back(-1)
            let rul = localStorage.getItem("history_url_caSeal");
            localStorage.removeItem("history_url_caSeal");
            if (rul.indexOf("#") > -1) {
              rul = rul.split("#")[1];
              let path = rul.split("?")[0];
              this.$router.replace({ path, query: rulTojson(rul) });
            }
          }
        }, 100);
      }
    },
    /**
     * @author 伟健 / 张
     * @name 获取公告未读数量
     * @param
     * @return
     */
    unreadMessageCount() {
      ajax.get({
        url: "/customer/message/unreadMessageCount",
        params: {},
        success: (res) => {
          this.messageCount = res;
        },
      });
    },
    // 没有二级目录的跳转
    directrouter(item, path) {
      if (item.paths) {
        if (item.paths.indexOf(this.menuIndex) != -1) {
          if (this.isH == "") {
            this.isH = path;
          } else {
            this.isH = "";
          }
        } else {
          this.isH = path;
          this.menuIndex = path;
          this.setParentMenu(path);
          this.push({ path });
        }
      } else {
        this.isH = path;
        this.menuIndex = path;
        this.setParentMenu(path);
        this.push({ path });
      }
    },
    setParentMenu(path) {
      this.menuChild = [];
      localStorage.setItem("menuChild", JSON.stringify([]));
      menusStructure.forEach((el) => {
        if (el.paths.indexOf(path) > -1) {
          this.menuChild = el.children;
          localStorage.setItem("menuChild", JSON.stringify(el.children));
        }
      });
    },
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
      if (!this.isCollapse && this.showAd) {
        this.adVisible = true;
      } else {
        this.adVisible = false;
      }
      this.$nextTick(() => {
        // this.resize();
      });
    },
    handleCloseAd() {
      this.adVisible = false;
      this.showAd = false;
    },
    reactiveMenu(pathArrary = []) {
      // 首页
      if (this.$route.path == "/" && pathArrary[0] == "/") {
        return true;
      }
      return pathArrary.indexOf(this.$route.path) > -1;
    },
    handleCommand(command) {
      if (command == "info") {
        this.menuKey = "user";
        this.push({ path: "/user/account/info" });
      }
      if (command == "password") {
        this.push({ path: "/user/account/modifyPasw" });
      }
      if (command == "exit") {
        ajax.post({
          url: "/customer/auth/logout",
          data: {},
          self: this,
          success: (res) => {
            if (res) {
              sessionStorage.removeItem("menuChild");
              this.back({ path: "/login" });
            }
          },
        });
      }
    },
    getAd() {
      ajax.post({
        url: "/customer/homePageData/displayAds",
        data: {},
        self: this,
        success: (res) => {
          if (res) {
            this.adList = res || [];
          }
        },
      });
    },

  },
  mounted() {
    if (isIE()) {
      window.addEventListener(
        "hashchange",
        () => {
          let currentPath = window.location.hash.slice(1);

          if (this.$route.path !== currentPath && this.$route.path.indexOf("/external") > -1) {
            window.location.reload();
          }
        },
        false
      );
      this.ca_back();
    }
    this.getAd();
    // Mirror.watch("loading_home_open", () => {
    //   this.showLoading = true;
    // });
    // Mirror.watch("loading_home_close", () => {
    //   this.showLoading = false;
    // });
    // let time = null;
    // Mirror.watch(['tips_bus', "tips_el_alert_box_open"], (key, msg) => {
    //   if (this.dgFormDialog) return;
    //   if (typeof msg == "string") {
    //     this.tips.msg = msg;
    //     this.tips.type = "error";
    //   } else if (msg) {
    //     clearInterval(time);
    //     this.tips.msg = msg.msg;
    //     this.tips.type = msg.type;
    //   }
    // });
    // 监听窗口变化
    window.onresize = () => {
      this.contentStyle.height = window.innerHeight - 60 + "px";
      this.contentStyle.width = Math.max(window.innerWidth - 200, 1200) + "px";
    };
  },
  created() {
    this.selectEventPoster();
    this.getContact();
    this.get_new_year_code()
    setInterval(() => {
      this.show_tag_txt = !this.show_tag_txt
    }, 2500)
    // if (localStorage.getItem("current")) {
    //   this.current = JSON.parse(localStorage.getItem("current"));
    // }
    if (!this.$route.query.appid) {
      this.$root.$on("unreadMessageCount", this.unreadMessageCount);
    }
    this.$root.$on("selectEventPoster", this.selectEventPoster);
    this.$root.$on("newCurrent", () => {
      this.current = JSON.parse(localStorage.getItem("current"));
    });
  },
};
</script>
<style scoped lang="less">
// @import "~@/assets/css/var.less";

.shadow {
  box-shadow: 2px 0px 12px 0px rgba(0, 0, 0, 0.05);
}

.aside {
  transition: all 0.3s;
}

.aside-box {
  .active {
    background-color: @themeBrightColor10 !important;
    border-radius: 4px;

    span,
    i {
      color: @theme !important;
    }
  }
}

.aside-box-collapse {
  .active {
    background-color: @themeBrightColor10 !important;
    color: @theme !important;
    border-radius: 4px;
  }
}

.el-main {
  padding: 0 !important;
  background-color: #f7f7f9;
}

.popper-class {
  padding: 8px 0 !important;
}

.popoverActive {
  background-color: @themeBrightColor10 !important;
  color: @theme !important;
  border-radius: 4px;
}

.popperclass {
  background-color: @theme;
}

.gg-wrap {
  // transition: 0.5s all ease-in-out;
  // opacity: 1;
  animation: fadeIn 0.3s ease-in;

  /deep/.el-carousel__button {
    width: 15px;
    height: 4px;
    border-radius: 10px;
    width: 15px;
  }

  &.none_indicator {
    /deep/.el-carousel__indicators {
      display: none;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

 

.new_year_code {
  background-image: url('../assets/img/new_year/new_year_bg.png');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.show_tag_txt {
  animation-duration: 2.5s;
  animation-name: tag_txt;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 1,
}

.show_tag_txt2 {
  animation-duration: 2.5s;
  animation-name: tag_txt2;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

@keyframes tag_txt {
  0% {
    opacity: 0;
  }

  25% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

@keyframes tag_txt2 {
  0% {
    opacity: 0;
  }

  33% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}
</style>